import React, { useEffect, useRef } from "react";
import { BiX } from "react-icons/bi";
import { Button } from "@delibrandev/utils";
import "./style.css";

export const Popup = ({
  isOpen,
  content,
  togglePopup,
  update = null,
  busy = false,
  label = null,
}) => {
  const contentRef = useRef(null);
  const closeRef = useRef(togglePopup);
  closeRef.current = togglePopup;
  useEffect(() => {
    if (!isOpen || !label) return;
    const previous = document.activeElement;
    const panel = contentRef.current;
    (panel?.querySelector("input,select,textarea") || panel)?.focus();
    const keydown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeRef.current?.();
      }
      if (event.key !== "Tab") return;
      const nodes = [
        ...panel.querySelectorAll(
          'input,select,textarea,button,[tabindex="0"]',
        ),
      ].filter(
        (element) => !element.matches(":disabled") && element.type !== "hidden",
      );
      if (!nodes.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      if (event.shiftKey && document.activeElement === nodes[0]) {
        event.preventDefault();
        nodes[nodes.length - 1].focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === nodes[nodes.length - 1]
      ) {
        event.preventDefault();
        nodes[0].focus();
      }
    };
    panel?.addEventListener("keydown", keydown);
    return () => {
      panel?.removeEventListener("keydown", keydown);
      if (previous?.isConnected) previous.focus();
    };
  }, [isOpen, label]);
  return (
    <div className={`popup ${isOpen ? "show" : ""}`}>
      <div
        className="popup-overlay"
        onClick={togglePopup}
        role="button"
        tabIndex={0}
        aria-label="Close popup"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            togglePopup();
          }
        }}
      ></div>
      <div
        className="popup-content"
        ref={contentRef}
        role={label ? "dialog" : undefined}
        aria-modal={label ? true : undefined}
        aria-label={label || undefined}
        tabIndex={label ? -1 : undefined}
      >
        <div
          className="popup-close"
          onClick={togglePopup}
          role="button"
          tabIndex={0}
          aria-label="Close popup"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              togglePopup();
            }
          }}
        >
          <BiX />
        </div>
        {content}
        {update !== null && (
          <Button
            text={busy ? "Guardando…" : "Guardar"}
            disabled={busy}
            icon={null}
            customClass={"customButtonColor2"}
            action={update}
          />
        )}
      </div>
    </div>
  );
};

export default Popup;
